module.exports = __webpack_public_path__ + "55e7a8aa2c3c78b8f07826cc3f419c6e.pdf";